export type ConfigHashMap = Record<string, string>;

export function computeStaleConfigTypes( server: ConfigHashMap | null, local: ConfigHashMap, types: readonly string[] ): string[]
{
  if ( !server ) return [ ...types ];
  return types.filter( type =>
  {
    const server_hash = server[type];
    const local_hash = local[type];
    if ( server_hash === undefined ) return local_hash !== undefined;
    return local_hash !== server_hash;
  } );
}

export type CachedConfigCheck = ( type: string ) => boolean;

// A stored hash says "this type is up to date", but the payload it describes
// lives in a separate storage key owned by the service. If that key is gone
// (a failed write, a partial clear), the hash would keep the type from ever
// being fetched again. Such hashes are dropped so the next comparison refetches.
export function hashesWithoutCache( local: ConfigHashMap, checks: ReadonlyMap<string, CachedConfigCheck> ): string[]
{
  const orphaned: string[] = [];
  for ( const [ type, is_cached ] of checks )
  {
    if ( local[type] === undefined ) continue;
    let cached = true;
    try { cached = is_cached( type ); }
    catch ( e ) { console.warn( `[ConfigSync] cache check failed for ${type}, keeping its hash`, e ); }
    if ( !cached ) orphaned.push( type );
  }
  return orphaned;
}
